<template>
  <div class="container mt-5" >
    <div class="card text-center floating-card ">
      <div class="card-header bg-primary text-white">Dashboard - Análisis de Desnutrición Crónica Infantil</div>
        <div class="row">

      <div class="card-body">
        <h5 class="card-title">
          Niños/as  <span class="text-primary">totales ingresados:</span>  {{ totalNinos }}
        </h5>
        <div>
          {{ s }}
        </div>
        <div class="floating-content">
          <img src="./../assets/iconoinfantesdashboard.png" alt="" width="175" height="200">
        </div>
      </div>
      <div class="card-body" >
        <h5 class="card-title" >
            Tasa de <span class="text-danger">Desnutrición Crónica Infantil</span>
        </h5>
        <div class="tamaño">
         <apexchart  width="300"  type="donut" :options="options" :series="series"></apexchart>
        </div>
      </div>
      <div class="card-body">
        <h5 class="card-title" >
            Número de <span class="text-success">Controles brindados</span>
        </h5>
        <div class="tamaño">
         <apexchart  width="350"  type="line" :options="optionscontroles" :series="series"></apexchart>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { BASE_URL } from '../store/config';

function obtenerNombreMes(fechaISO) {
  const meses = [
    'ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'
  ];

  const fecha = new Date(fechaISO);
  const año = fecha.getFullYear();
  const mesIndex = fecha.getMonth();
  return `${año}-${mesIndex + 1 < 10 ? '0' : ''}${mesIndex + 1} ${meses[mesIndex]}`;

}

export default {
    data() {
      return {
        niños: [],
        controles: [],
        desnutricion: [],
        totalNinos: null,
        totalControles: null,
        totalDesnutricion: null,
        errorLoadingNiños: null,
        errorLoadingControl: null,
        errorLoadingDesnutricion: null,
        options: {
        },
        optionscontroles: {
        },
        seriescontrol: 30,
        totalDesnutricionNiños : 0,
        totalPorcentajeDesnutricion:0
      };
    },
    computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
   
},
    methods: {
      loadNiños() {
        axios
          .get(`${BASE_URL}/api/nino`, {
            headers: {
              'x-access-token': this.$store.state.auth.user.accessToken,
            },
          })
          .then(response => {
            this.niños = response.data;
            this.actualizarGrafico();
          })
          .catch(error => {
            this.errorLoadingNiños = 'Error al cargar niños. Por favor, inténtalo de nuevo.';
            console.error('Error al cargar niños:', error);
          });
      },
      loadControl() {
        axios
          .get(`${BASE_URL}/api/control/reporte`, {
            headers: {
              'x-access-token': this.$store.state.auth.user.accessToken,
            },
          })
          .then(response => {
            this.controles = response.data;
            this.actualizarGrafico();
          })
          .catch(error => {
            this.errorLoadingControl = 'Error al cargar los controles. Por favor, inténtalo de nuevo.';
            console.error('Error al cargar control:', error);
          });
      },
      loadDesnutrición() {
  axios
    .get(`${BASE_URL}/api/control/reporte`, {
      headers: {
        'x-access-token': this.$store.state.auth.user.accessToken,
      },
    })
    .then(response => {
      const registrosPorNiño = response.data.reduce((acc, niño) => {
        const key = niño.ninoId._id; 
        if (!acc[key] || acc[key].fecha < niño.fecha) {
          acc[key] = niño;
        }
        return acc;
      }, {});

      this.desnutricion = Object.values(registrosPorNiño);
      this.calcularEstadoDesnutricion(); 
      
    })
    .catch(error => {
      this.errorLoadingDesnutricion = 'Error al cargar desnutricioón. Por favor, inténtalo de nuevo.';
      console.error('Error al cargar datos desnutrición:', error);
    });
},    
calcularEstadoDesnutricion() {
  // Recorre los registros de cada niño y calcula el estado de desnutrición
  this.desnutricion.forEach(niño => {
    const { edad, peso, longitud } = niño;

    let estadoDesnutricion = '';

    switch (edad) {
  case 1:
    if (peso < 4.3 - 1 || peso > 4.3 + 1 || longitud < 54.6 - 5 || longitud > 54.6 + 5) {
      estadoDesnutricion = peso > 4.3 + 1 ? 'Sobrepeso' : (peso < 4.3 - 1 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 2:
    if (peso < 5.2 - 2 || peso > 5.2 + 2 || longitud < 58.1 - 5 || longitud > 58.1 + 5) {
      estadoDesnutricion = peso > 5.2 + 2 ? 'Sobrepeso' : (peso < 5.2 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 3:
    if (peso < 6.0 - 2 || peso > 6.0 + 2 || longitud < 61.1 - 5 || longitud > 61.1 + 5) {
      estadoDesnutricion = peso > 6.0 + 2 ? 'Sobrepeso' : (peso < 6.0 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 4:
    if (peso < 6.7 - 2 || peso > 6.7 + 2 || longitud < 63.7 - 5 || longitud > 63.7 + 5) {
      estadoDesnutricion = peso > 6.7 + 2 ? 'Sobrepeso' : (peso < 6.7 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 5:
    if (peso < 7.3 - 2 || peso > 7.3 + 2 || longitud < 65.9 - 5 || longitud > 65.9 + 5) {
      estadoDesnutricion = peso > 7.3 + 2 ? 'Sobrepeso' : (peso < 7.3 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 6:
    if (peso < 7.8 - 2 || peso > 7.8 + 2 || longitud < 67.8 - 5 || longitud > 67.8 + 5) {
      estadoDesnutricion = peso > 7.8 + 2 ? 'Sobrepeso' : (peso < 7.8 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 7:
    if (peso < 8.3 - 2 || peso > 8.3 + 2 || longitud < 69.5 - 5 || longitud > 69.5 + 5) {
      estadoDesnutricion = peso > 8.3 + 2 ? 'Sobrepeso' : (peso < 8.3 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 8:
    if (peso < 8.8 - 2 || peso > 8.8 + 2 || longitud < 71.0 - 5 || longitud > 71.0 + 5) {
      estadoDesnutricion = peso > 8.8 + 2 ? 'Sobrepeso' : (peso < 8.8 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 9:
    if (peso < 9.2 - 2 || peso > 9.2 + 2 || longitud < 72.3 - 5 || longitud > 72.3 + 5) {
      estadoDesnutricion = peso > 9.2 + 2 ? 'Sobrepeso' : (peso < 9.2 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 10:
    if (peso < 9.5 - 2 || peso > 9.5 + 2 || longitud < 73.6 - 5 || longitud > 73.6 + 5) {
      estadoDesnutricion = peso > 9.5 + 2 ? 'Sobrepeso' : (peso < 9.5 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 11:
    if (peso < 9.9 - 2 || peso > 9.9 + 2 || longitud < 74.9 - 5 || longitud > 74.9 + 5) {
      estadoDesnutricion = peso > 9.9 + 2 ? 'Sobrepeso' : (peso < 9.9 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 12:
    if (peso < 10.2 - 2 || peso > 10.2 + 2 || longitud < 76.1 - 5 || longitud > 76.1 + 5) {
      estadoDesnutricion = peso > 10.2 + 2 ? 'Sobrepeso' : (peso < 10.2 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 13:
    if (peso < 10.2 - 2 || peso > 10.2 + 2 || longitud < 76.1 - 5 || longitud > 76.1 + 5) {
      estadoDesnutricion = peso > 10.2 + 2 ? 'Sobrepeso' : (peso < 10.2 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 14:
    if (peso < 10.2 - 2 || peso > 10.2 + 2 || longitud < 76.1 - 5 || longitud > 76.1 + 5) {
      estadoDesnutricion = peso > 10.2 + 2 ? 'Sobrepeso' : (peso < 10.2 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 15:
    if (peso < 11.1 - 2 || peso > 11.2 + 2 || longitud < 79 - 5 || longitud > 79+ 5) {
      estadoDesnutricion = peso > 11.2 + 2 ? 'Sobrepeso' : (peso < 11.2 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 16:
    if (peso < 11.1 - 2 || peso > 11.2 + 2 || longitud < 79 - 5 || longitud > 79+ 5) {
      estadoDesnutricion = peso > 11.2 + 2 ? 'Sobrepeso' : (peso < 11.2 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 17:
    if (peso < 11.1 - 2 || peso > 11.2 + 2 || longitud < 79 - 5 || longitud > 79+ 5) {
      estadoDesnutricion = peso > 11.2 + 2 ? 'Sobrepeso' : (peso < 11.2 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 18:
    if (peso < 11.8 - 2 || peso > 11.8 + 2 || longitud < 82.5 - 5 || longitud > 82.5 + 5) {
      estadoDesnutricion = peso > 11.8 + 2 ? 'Sobrepeso' : (peso < 11.8 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 19:
    if (peso < 11.8 - 2 || peso > 11.8 + 2 || longitud < 82.5 - 5 || longitud > 82.5 + 5) {
      estadoDesnutricion = peso > 11.8 + 2 ? 'Sobrepeso' : (peso < 11.8 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 20:
    if (peso < 11.8 - 2 || peso > 11.8 + 2 || longitud < 82.5 - 5 || longitud > 82.5 + 5) {
      estadoDesnutricion = peso > 11.8 + 2 ? 'Sobrepeso' : (peso < 11.8 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 21:
    if (peso < 11.8 - 2 || peso > 11.8 + 2 || longitud < 82.5 - 5 || longitud > 82.5 + 5) {
      estadoDesnutricion = peso > 11.8 + 2 ? 'Sobrepeso' : (peso < 11.8 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 22:
    if (peso < 11.8 - 2 || peso > 11.8 + 2 || longitud < 82.5 - 5 || longitud > 82.5 + 5) {
      estadoDesnutricion = peso > 11.8 + 2 ? 'Sobrepeso' : (peso < 11.8 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 23:
    if (peso < 11.8 - 2 || peso > 11.8 + 2 || longitud < 82.5 - 5 || longitud > 82.5 + 5) {
      estadoDesnutricion = peso > 11.8 + 2 ? 'Sobrepeso' : (peso < 11.8 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 24:
    if (peso < 12.9 - 2 || peso > 12.9 + 2 || longitud < 88 - 5 || longitud > 88 + 5) {
      estadoDesnutricion = peso > 12.9 + 2 ? 'Sobrepeso' : (peso < 12.9 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  default:
    estadoDesnutricion = 'No evaluado';
    break;
}


    niño.estadoDesnutricion = estadoDesnutricion;
    this.totalDesnutricionNiños = this.desnutricion.filter(niño => niño.estadoDesnutricion === 'Desnutrición').length;
    const totalNiños = this.niños.length;
    const porcentaje = (this.totalDesnutricionNiños / totalNiños) * 100;

    this.options = {
        colors: ["#FF6384"],
        series: [porcentaje.toFixed(2)],
          chart: {
          type: 'radialBar',
       
        },
        plotOptions: {
          radialBar: {
            hollow: {
              size: '70%',
            },
           
            
          },

        },
        dataLabels: {
              name: {
                show: false
              },
             
            },
        labels: [``],
        } 

  });
},
      actualizarGrafico() {
      this.totalNinos = this.niños.length;
      this.totalControles = this.controles.length;
     
      
    

      //Lógica para no manejar mes repetidos  
      const nombresMesesSet = new Set(this.controles.map(control => obtenerNombreMes(control.fecha)));
      const nombresMeses = Array.from(nombresMesesSet);
      
   

       //Lógica para extrar el total de control de acuerdo al Mes 
      const controlesPorMes = {};

      this.controles.forEach(control => {
          const nombreMes = obtenerNombreMes(control.fecha);

          if (!controlesPorMes[nombreMes]) {
            controlesPorMes[nombreMes] = 1;
          } else {
            controlesPorMes[nombreMes]++;
          }
      });
      

       //Controles brindados totales por meses
       this.optionscontroles = {
        colors: ["#2ECC71"],
        series: [{
            name: "Controles",
            data: Object.values(controlesPorMes),
        }],
          chart: {
          height: 220,
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: true
        },
        stroke: {
          curve: 'straight'
        },
        title: {
          text: 'Controles',
          align: 'left'
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          },
        },
        xaxis: {
       categories: nombresMeses
     .map(fecha => fecha.split(' ')[0])
     .sort()
}

        };

   

      },


    },
    mounted() {
      this.actualizarGrafico();
      this.loadNiños();
      this.loadControl();
      this.loadDesnutrición();
      this.calcularEstadoDesnutricion(); 

    
      
  

    },
  };
  </script>
  
  <style>
  .floating-card {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
    transition: box-shadow 0.3s ease-in-out;
  }
  
  .floating-content {
    transform: translate3d(0, -5px, 0);
    transition: transform 0.3s ease-in-out;
  }

  .tamaño{
    height: 200px;
  }


  </style>